const mortgageData = {
  household: 'Bank Street Mortgage Journey',
  currency: 'AUD',
  startPrincipal: 852908.12,
  snapshots: [
    {
      month: '2025-10',
      loanBalance: 852908.12,
      offsetBalance: 0,
      requiredRepayment: 4727,
      extraRepayment: 0,
      interestPaid: 0,
      note: 'Mortgage Start',
    },
    {
      month: '2025-11',
      loanBalance: 848181.12,
      offsetBalance: 38000,
      requiredRepayment: 4727,
      extraRepayment: 0,
      interestPaid: 0,
    },
    {
      month: '2025-12',
      loanBalance: 846961.87,
      offsetBalance: 38000,
      requiredRepayment: 4727,
      extraRepayment: 0,
      interestPaid: 3506.98,
    },
    {
      month: '2026-01',
      loanBalance: 845789.87,
      offsetBalance: 38000,
      requiredRepayment: 4727,
      extraRepayment: 0,
      interestPaid: 3555.77,
    },
    {
      month: '2026-02',
      loanBalance: 842938.1,
      offsetBalance: 38000,
      requiredRepayment: 4727,
      extraRepayment: 0,
      interestPaid: 3656.35,
    },
    {
      month: '2026-03',
      loanBalance: 841398.42,
      offsetBalance: 328036.25,
      requiredRepayment: 4727,
      extraRepayment: 0,
      interestPaid: 3187.32,
      note: "Ivy's Townhouse Sold",
    },
    {
      month: '2026-04',
      loanBalance: 838881.76,
      offsetBalance: 330380.17,
      requiredRepayment: 4727,
      extraRepayment: 0,
      interestPaid: 2210.35,
    },
    {
      month: '2026-05',
      loanBalance: 836365.12,
      offsetBalance: 335086.16,
      requiredRepayment: 4853,
      extraRepayment: 0,
      interestPaid: 2519.86,
      note: 'Ivy added $3500 to her savings',
    },
  ],
  storyEvents: [
    {
      date: '2026-03-01',
      title: 'Townhouse Sale Proceeds Added',
      description: 'Ivy townhouse sold and proceeds moved into offset.',
      amount: 290036.25,
      type: 'offset-boost',
    },
    {
      date: '2026-05-01',
      title: 'Extra Savings Injection',
      description: 'Additional $3,500 contributed to accelerate full offset progress.',
      amount: 3500,
      type: 'milestone',
    },
  ],
};

export default mortgageData;